import { Component, OnInit } from '@angular/core';
import Swiper from 'swiper';
import { Router } from '@angular/router';
import {MatCardModule} from '@angular/material/card';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  elem;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.elem = document.documentElement;


    document.querySelectorAll('.feedback li').forEach(entry => entry.addEventListener('click', e => {

      if(!entry.classList.contains('active')) {

          document.querySelector('.feedback li.active').classList.remove('active');
          entry.classList.add('active');
      }
      e.preventDefault();
  }));


  }


  happy(){

  }
  ok(){

  }
  good(){

  }

 submit(){
  this.router.navigate(['final']);
 }

}
